import { Injectable, inject } from '@angular/core';
import { TrackingService } from '../../../core/services/tracking.service';

/** Optional completion analytics: preserve SDK dependency order without delaying payment continuation. */
@Injectable({ providedIn: 'root' })
export class RegistrationTracking {
  private readonly tags = inject(TrackingService);

  async track(type: string, studioId: string): Promise<void> {
    await Promise.allSettled([
      this.tags.injectTag('assets/studioTags/tag_sf_3_478.html'),
      ...(type === 'new_membership' && studioId ? [this.tags.injectTag(`assets/studioTags/studioTagParts_${studioId}.html`)] : []),
      this.lineConversion(),
    ]);
  }

  private async lineConversion(): Promise<void> {
    await this.tags.injectTag('assets/indexTags/head/240.html');
    // A failed/missing base asset cannot supply the conversion SDK, even when its loader resolves.
    if (typeof (globalThis as { _lt?: unknown })._lt === 'function') {
      await this.tags.injectTag('assets/studioTags/line_conversion.html');
    }
  }
}
